import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Disclaimer from '../disclaimer/Disclaimer';
import CTAButton from '../ctaButton/CTAButton';
import classNames from 'classnames';

const CTAWrapper = ({ cta }) => {
  if (!cta) return null;
  return cta.map((callToAction, i) => <CTAButton key={`tc-button_${i}`} {...callToAction} />);
};

export const TextContentInner = (props) => {
  if (!props.src && !props.markdownText && !props.text) return null;

  let outputString = '';

  if (props.src || props.markdownText) {
    outputString = props.src ? props[props.src] : props.markdownText;
  } else {
    outputString = `<p>${props.text}</p>`;
  }

  return (
    <div className={props.className || 'text-content__inner'} dangerouslySetInnerHTML={{ __html: outputString }} />
  );
};

const TextContent = (props) => {
  const {
    width,
    colourScheme,
    customPadding,
    callToAction,
    disclaimer,
    titleColour,
    textSize = 'medium',
    alignment,
    mobileAlignment,
    overHeader,
    sectionId,
    hideOnDesktop,
    hideOnMobile,
    children,
    sectionClass
  } = props;

  const componentClasses = classNames('text-content', {
    'text-content--no-padding-top': customPadding === 'no-top',
    'text-content--no-padding-bottom': customPadding === 'no-bottom',
    'text-content--no-padding-top-bottom': customPadding === 'no-padding',
    'fluid-small-only': hideOnDesktop,
    'text-content--hide-on-mobile': hideOnMobile,
    'text-content--over-header': overHeader,
    [`text-content--mobile-${mobileAlignment}-align`]: mobileAlignment,
    [`text-content--${alignment}-align`]: alignment,
    [`text-content--${width}-width`]: width,
    [`text-content--text-size-${textSize}`]: textSize,
    [`titles--${titleColour}`]: titleColour,
    [`text-content--${colourScheme}-scheme`]: colourScheme,
    [`${sectionClass}`]: sectionClass
  });

  return (
    <Fragment>
      <section className={componentClasses} id={sectionId}>
        <TextContentInner className="text-content__inner" {...props} />
        <CTAWrapper cta={callToAction} />

        {children}

        {disclaimer ? (
          <div
            className="disclaimer disclaimer--no-padding-top-bottom"
            dangerouslySetInnerHTML={{ __html: props[disclaimer.src] }}
          />
        ) : null}
      </section>
    </Fragment>
  );
};

TextContent.propTypes = {
  src: PropTypes.string,
  text: PropTypes.string,
  markdownText: PropTypes.string,
  width: PropTypes.oneOf(['half', 'full', 'footer', 'four-fifths', 'no-gutters']),
  customPadding: PropTypes.oneOf(['no-top', 'no-bottom', 'no-padding']),
  colourScheme: PropTypes.oneOf([
    'grey',
    'dark-navy',
    'light-grey',
    'white',
    'gradient',
    'teal',
    'neutral-navy',
    'neutral-teal',
    'sand'
  ]),
  titleColour: PropTypes.oneOf(['purple', 'dark-navy', 'teal']),
  textSize: PropTypes.oneOf(['medium', 'large']),
  alignment: PropTypes.oneOf(['left', 'right', 'center']),
  mobileAlignment: PropTypes.oneOf(['left']),
  overHeader: PropTypes.bool,
  sectionId: PropTypes.string,
  hideOnDesktop: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  children: PropTypes.node,
  sectionClass: PropTypes.string,
  disclaimer: PropTypes.oneOfType([
    PropTypes.shape(Disclaimer.propTypes),
    PropTypes.arrayOf(PropTypes.shape(Disclaimer.propTypes))
  ]),
  callToAction: PropTypes.arrayOf(PropTypes.shape(CTAButton.propTypes))
};

export default TextContent;
